/**
 * Centralized brand configuration — single source of truth.
 *
 * Host-aware: GreenONE on green-one.cz (V3 deployment), Solar Green elsewhere
 * (poptavka.solar-green.cz V2 + preview). Resolved ONCE at module load — the
 * hostname never changes within a session, so this avoids any per-render cost.
 *
 * Scope: this controls the *product / app-chrome* identity (admin headers,
 * login, presentation, browser tab title, loading screen). The *legal billing
 * entity* ("Solar Green s.r.o." used in invoices / contracts / PDFs) is kept
 * separate via `legalName` and the DB `company_name` setting and is NOT changed
 * by this brand switch.
 */
const GREENONE_HOSTS = new Set(["green-one.cz", "www.green-one.cz"]);

const _host =
  typeof window !== "undefined" ? (window.location.hostname || "").toLowerCase() : "";

export const IS_GREENONE = GREENONE_HOSTS.has(_host);

const GREENONE = {
  productName: "GreenONE",
  shortName: "G1",
  subtitle: "CRM platforma",
  tagline: "CRM platforma",
  why: "Proč GreenONE?",
  productLine: "GreenONE CRM platforma · od roku 2019",
  demoSubject: "Demo GreenONE",
  demoHref: "/poptavka",
  tabTitle: "GreenONE · CRM platforma",
  loadingText: "Načítám GreenONE...",
  legalName: "Solar Green s.r.o.",
};

const SOLAR_GREEN = {
  productName: "Solar Green",
  shortName: "SG",
  subtitle: "GreenOS · CRM platforma",
  tagline: "Administrační systém",
  why: "Proč GreenOS?",
  productLine: "GreenOS CRM platforma · od roku 2019",
  demoSubject: "Demo GreenOS",
  demoHref: "#demo",
  tabTitle: null,
  loadingText: "Načítám Solar Green...",
  legalName: "Solar Green s.r.o.",
};

export const BRAND = Object.freeze(IS_GREENONE ? GREENONE : SOLAR_GREEN);

export default BRAND;
